import { useTranslation } from "react-i18next"
import { Stack, Tooltip } from "@mui/material"
import WarningIcon from "@mui/icons-material/WarningRounded"

import type { ContextDevice } from "types/device.types"

import ReportingStatus from "widgets/device/ReportingStatus"

type DeviceStatusMarksProps = Pick<ContextDevice, "status" | "hasAlert">

/** What a device shows after its name: its reporting status, and the devices table's warning when an alert triggered. */
const DeviceStatusMarks = ({ status, hasAlert }: DeviceStatusMarksProps) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" alignItems="center" gap={0.5} flexShrink={0}>
      <ReportingStatus status={status} variant="icon" />
      {hasAlert && (
        <Tooltip title={t("alerts.TRIGGERED_ALERT")}>
          <WarningIcon color="error" fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  )
}

export default DeviceStatusMarks
